/* Salmatcha · design-system pass — staggered reveal for lists (desktop only).
   Fail-open: an element is only hidden after the observer exists and only if
   it is below the fold; everything is force-revealed after 4s regardless. */
(function () {
  'use strict';
  if (window.__salSystemInit) return;
  window.__salSystemInit = true;

  /* editorial pass: give the theme-owned sections (best sellers, club) the same
     indexed kicker the sal-* sections render in Liquid */
  function indexHeads() {
    try {
      var mk = function (text) {
        var d = document.createElement('div'); d.className = 'sal-index';
        d.innerHTML = '<span class="sal-index__num" aria-hidden="true"></span><em></em>';
        d.querySelector('em').textContent = text; return d;
      };
      document.querySelectorAll('.sf__product-tab').forEach(function (sec) {
        if (sec.classList.contains('sal-row--sub')) return; /* sub-rows keep their own small header */
        if (sec.querySelector('.sal-index')) return;
        var head = sec.querySelector('.section__header');
        var heading = head && head.querySelector('.section__heading');
        if (!head || !heading) return;
        var sub = head.querySelector('.section__description, .section__subheading');
        var label = (sub && sub.textContent.trim()) || 'Shop';
        if (sub) sub.style.display = 'none';
        head.insertBefore(mk(label), heading);
      });
      document.querySelectorAll('.app-wrapper .section__header').forEach(function (head) {
        if (head.querySelector('.sal-index')) return;
        var heading = head.querySelector('.section__heading'); if (!heading) return;
        var sub = head.querySelector('.section__subheading');
        var secId = (head.closest('.shopify-section') || {}).id || '';
        head.insertBefore(mk(/contact|inquiry|form/i.test(secId) ? 'Get in touch' : 'Community'), heading);
        if (sub) head.appendChild(sub); /* subheading reads after the heading */
      });
      document.querySelectorAll('.sf__newsletter-section .newsletter__form-heading').forEach(function (head) {
        if (head.querySelector('.sal-index')) return;
        var d = mk('The club'); d.classList.add('sal-index--light'); d.style.justifyContent = 'center';
        head.insertBefore(d, head.firstChild);
      });
    } catch (e) { /* fail-open */ }
  }

  function init() {
    indexHeads();
    try {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(max-width: 767px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var groups = ['.sal-benefits__grid', '.sal-reviews__grid', '.sal-goals__grid', '.sal-craft__grid',
        '.sal-categories__grid', '.sal-highlights__grid', '.sal-timeline__grid',
        '.sal-bestseller-tabs .sf-mixed-layout__wrapper'];
      var els = [];
      groups.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (grid) {
          var kids = Array.prototype.slice.call(grid.children).filter(function (k) { return k.offsetWidth > 0; });
          kids.forEach(function (k, i) {
            if (k.getBoundingClientRect().top < window.innerHeight * 0.9) return; /* visible now: never hide */
            k.style.setProperty('--sal-stagger', Math.min(i * 55, 330) + 'ms');
            k.classList.add('sal-will-reveal');
            els.push(k);
          });
        });
      });
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sal-revealed'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
      setTimeout(function () { els.forEach(function (el) { el.classList.add('sal-revealed'); }); }, 4000);
    } catch (e) {
      document.querySelectorAll('.sal-will-reveal').forEach(function (el) { el.classList.add('sal-revealed'); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
